module.exports = __webpack_public_path__ + "img/avatar-stella-guan.2d1169ce.jpg";